import { useState } from "react";
import { Context } from "common/types/context";
import { JoinItem } from "common/query/types";
import { DeleteButton } from "common/ui/buttons";
import { Modal } from "common/widgets/modal";
import { ValueProps } from "common/with-value-for";
import { Config } from "x/layout/explorer-panel/explorer/types";
import { ConfigComponent } from "./config";

interface PropTypes extends ValueProps<Config> {
  context: Context;
  entity: string;
  joins: JoinItem[];
  onApply: (config: Config) => void;
  onCancel: () => void;
}

export const ExplorerModal = ({
  context,
  entity,
  joins,
  value,
  onApply,
  onCancel,
}: PropTypes) => {
  const [modalValue, setModalValue] = useState(value);

  const onReset = () => setModalValue(undefined);

  const content = (
    <ConfigComponent
      context={context}
      value={modalValue}
      entity={entity}
      joins={joins}
      onChange={setModalValue}
    />
  );

  const deleteButton = (
    <DeleteButton role="button" onClick={onReset}>
      {_("Reset")}
    </DeleteButton>
  );

  return (
    <Modal
      content={content}
      size="large"
      title={_("Modify Table Filter")}
      okLabel={_("Apply")}
      onOk={() => onApply(modalValue)}
      onCancel={onCancel}
      footerButtons={deleteButton}
    />
  );
};
